"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _coreLog = _interopRequireDefault(require("../core-log"));
var _coreUuid = _interopRequireDefault(require("../core-uuid"));
var _send = require("./send");
var _getConfig = require("../core-messaging/dispatch/get-config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*
 Copyright (c) 2018 Wells Fargo. 333 Market St., San Francisco, CA 94105 All rights reserved.
 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.
 */ /**
 * Handles all iframe messaging. This module is used on both sides of the iframe boundary by
 * the SDK bootstrap component resident in parent/partner DOM and in the SDK component resident
 * in the IFRAME DOM. This component communicates with itself across the iframe boundary.
 *
 * As this component communiciates with itself, the concept of "conversation starter" and
 * "conversation responder" is used throughout. The SDK BOOTSTRAP component is the "conversation
 * starter" and the SDK JS in the IFRAME is the "conversation responder".
 *
 * On initialization, a message dispatch object is supplied to support various message actions.
 * The side that is initiating the conversation will also supply a targetOrigin on initialization.
 *
 * - This component will pin a received nonce and targt origin from the first valid message
 * received.
 * - sender nonce generation and validation upon receipt
 * - receiver nonce pinning on "initialize" action receipt and send with every message
 * - target origin pinning on first message receipt and validation with every message
 * - configurable received message dispatch by action
 *
 * @module core-messaging
 *
 * @author Nathan Freeling
 * @copyright 2018 Wells Fargo, All rights reserved.
 */
/**
 * A dispatch object with "{string} action" keys and "function" handlers
 */
var dispatcher = {};

// my nonce, I send this to them and they include it in all messages sent to me
var myNonce = _coreUuid["default"].uuid();

// my own origin, used to allow communications from frames with my same origin
// for SDK iframe <-> iframe communications
var myOrigin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');

/**
 * resets the message action dispatcher to default configuration
 */
function reset() {
  dispatcher = {};
  myNonce = _coreUuid["default"].uuid();
  window.removeEventListener('message', dispatchMessage, false);
  (0, _send.setTargetOrigin)(null);
  (0, _send.setTheirNonce)(null);
  (0, _send.setId)(null);
}

/**
 * Adds a set of action handlers to the dispatcher. New action handlers can
 * override existing action handlers so be careful.
 *
 * @param {object} handlers Additional handlers to register
 */
function addActionHandlers(handlers) {
  dispatcher = _objectSpread(_objectSpread({}, dispatcher), handlers);
}

/**
 * initializes the message action dispatcher
 *
 * @param {object} dispatchConfig The dispatch configuration
 * @param {object} [targetOrigin] Optional target origin, supply this for
 * the module that is initiating iframe communication
 */
function initialize(dispatchConfig, targetOrigin) {
  dispatcher = dispatchConfig;
  if (targetOrigin) {
    (0, _send.setTargetOrigin)(targetOrigin);
  }

  // postMessage API binding
  window.removeEventListener('message', dispatchMessage, false);
  window.addEventListener('message', dispatchMessage, false);
}

/**
 * Request initialization of an SDK in IFRAME DOM
 *
 * @param {object} destination optional message destination, defaults to window.parent
 * @param {object} destinationNonce optional their nonce to be validated by the receiver,
 *   defaults to cached destination nonce
 * @param {object} destinationID optional destination id, defaults to cached destination ID
 */
function sendInitialize(destination, destinationNonce, destinationID) {
  var data = {
    nonce: myNonce
  };
  (0, _send.sendMessage)({
    action: 'initialize',
    data: data,
    destination: destination,
    overrideNonce: destinationNonce,
    overrideID: destinationID
  });
}

// IFRAME COMMUNICATION

/**
 * Validates and dispatches an inbound message
 *
 * - Target Origin: pins target origin on first message receipt, validates target origin
 *   for subsequent messages
 * - Parses the message
 * - Sender Nonce: validates sender nonce for all actions except the "initialize" action
 * - "initialize" action handling:
 *   - Receiver Nonce: pins receiver nonce on an "initialize" action
 *   - Responds with a "getConfig" message on an "initialize" action
 * - dispatch of other actions
 * - logs unrecognized actions
 *
 * @param {string} event A JSON string response payload
 */
function dispatchMessage(event) {
  // DISCARD EMPTY/INVALID MESSAGES
  if (!event.data || event.data === 'undefined' || typeof event.data !== 'string') {
    // missing event data
    _coreLog["default"].log('Error: received an iframe post message with missing/invalid data.');
    return;
  }

  // VALIDATE TARGET ORIGIN
  // if we have a pinned origin, validate the event origin
  if ((0, _send.getTargetOrigin)() && !validateOrigin(event.origin)) {
    // bad target origin
    _coreLog["default"].log('Error: received an iframe post message from a different origin:' + event.origin);
    return;
  }

  // PARSE PAYLOAD
  var payload = {};
  try {
    payload = JSON.parse(event.data);
  } catch (ex) {
    // bad payload
    _coreLog["default"].log('Error: Received an iframe post message with an invalid payload');
    return;
  }
  var action = payload.action;

  // if we don't have a pinned target origin
  if (!(0, _send.getTargetOrigin)()) {
    // if the action is initialize
    if (action === 'initialize') {
      // pin the event.origin so we can accept messages from this origin in the future
      (0, _send.setTargetOrigin)(event.origin);
    } else {
      // invalid event origin, exit
      _coreLog["default"].log("Error: received an iframe post message from ".concat(event.origin, " before pinning"));
      return;
    }
  }
  var reflectedNonce = payload.nonce;
  var data = payload.data;

  // set global id var
  (0, _send.setId)(payload.id);

  // validate nonce for all calls except the first 'initialize' call
  if (!validateNonce(reflectedNonce, action)) {
    // bad payload structure, data and/or nonce
    _coreLog["default"].log('Error: Received an iframe post message with an invalid nonce');
    return;
  }
  _coreLog["default"].log('Received IFRAME post message with action: ' + action);

  // callbacks are a composite action separated by : e.g. callback:general:error
  // in this case, the actionKey is the first token
  var actionKey = 'not_provided';
  if (action) {
    var actionParts = action.split(':');
    actionKey = actionParts[0];
  }
  if (actionKey === 'initialize') {
    (0, _getConfig.getConfig)(data, myNonce);
  } else if (typeof dispatcher[actionKey] === 'function') {
    dispatcher[actionKey](data, payload.id, action);
  } else {
    _coreLog["default"].log('Error: Received IFRAME post message with unrecognized action: ' + actionKey);
  }
}

/**
 * Validates the supplied nonce within the supplied action context
 *
 * - If the action is 'initialize' then no nonce is expected.
 * - If the action is not 'initialize' then we expect the supplied nonce
 * to be equal to our stored nonce.
 *
 * @param {string} nonce The nonce to validate
 * @param {string} action The action context of this validation
 * @return {boolean} true if the nonce is valid, false otherwise
 */
function validateNonce(nonce, action) {
  return !nonce && action === 'initialize' || nonce === myNonce;
}

/**
 * Validates the supplied origin to see if it matches either the originator of the first
 * message to this iframe OR the same origin as this iframe (other SDK iframes)
 *
 * if the `iframeTargetOrigin` is set to "*" on initialization (for testing purposes), then
 * all origins are treated as valid.
 *
 * @param {*} origin The origin to validate
 * @return {boolean} true if the origin is valid, false otherwise
 */
function validateOrigin(origin) {
  var myTargetOrigin = (0, _send.getTargetOrigin)();
  return myTargetOrigin === '*' || myTargetOrigin === origin || myOrigin === origin;
}
var _default = exports["default"] = {
  initialize: initialize,
  reset: reset,
  sendInitialize: sendInitialize,
  sendMessage: _send.sendMessage,
  addActionHandlers: addActionHandlers
};
//# sourceMappingURL=index.js.map